import type { IPost } from "../../../../types/models/post.models.types";
import { usePostHttp } from "../../http.hook";

interface IBody {
	campaignId: string;
	handle: string;
	userId: string;
	fixedPayoutAmount: number;
}

interface IResponse {
	post: IPost;
}

export function useCreateVendorDraftAdminHttp() {
	return usePostHttp<IBody, IResponse>({
		path: "/admin/posts/vendor-draft",
	});
}
